<template>
  <div>
    <div class="row">
      <div class="col-12 mt-3">
        <Card body-classes="p-3" card-classes="shadow-sm">
          <template #header>
            <div class="d-flex flex-row align-items-center justify-content-between">
              <h5 class="mb-0 text-primary">
                <vue-feather type="calendar" class="me-2"></vue-feather>
                Monthly Product Sales with Stock - {{ store.name }}
              </h5>
              <div class="d-flex align-items-center gap-3">
                <div class="d-flex align-items-center">
                  <label for="year" class="me-2 text-muted">Year:</label>
                  <input type="number" id="year" class="form-control form-control-sm" v-model="year" min="2020" :max="currentYear">
                </div>
                <div class="d-flex align-items-center">
                  <label for="month" class="me-2 text-muted">Month:</label>
                  <select id="month" class="form-select form-select-sm" v-model="month">
                    <option value="1">January</option>
                    <option value="2">February</option>
                    <option value="3">March</option>
                    <option value="4">April</option>
                    <option value="5">May</option>
                    <option value="6">June</option>
                    <option value="7">July</option>
                    <option value="8">August</option>
                    <option value="9">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                  </select>
                </div>
                <button class="btn btn-primary btn-sm" @click="getReport">
                  Generate Report
                </button>
              </div>
            </div>
          </template>
          <div>
            <div v-if="loading" class="text-center py-5">
              <Spinner spinner-class="mb-1" />
              <p class="text-muted mt-2">Loading monthly product sales...</p>
            </div>
            <div v-else-if="reportData.length > 0">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>SKU</th>
                      <th>Product Name</th>
                      <th>Quantity Sold</th>
                      <th>Current Stock</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in reportData" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.sku || 'N/A' }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.quantity_sold + ' pcs' }}</td>
                      <td>{{ item.current_stock + ' pcs' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else class="alert alert-info">
              <vue-feather type="info" size="18" class="me-2"></vue-feather>
              No data available for the selected period.
            </div>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import {decrypt} from "@/utils/crypto";
import analyticsService from "@/api/analyticsService";

export default {
  name: "MonthlyProductSales",

  data(){
    return {
      profile: {},
      store: {},
      loading: false,
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      reportData: [],
      currentYear: new Date().getFullYear()
    }
  },

  methods: {
    async getReport() {
      this.loading = true;
      try {
        const params = {
          store_id: this.store.id,
          year: this.year.toString(),
          month: this.month.toString()
        };

        const response = await analyticsService.getMonthlyProductSalesWithStock(params);
        this.reportData = response || [];
      } catch(e) {
        console.error(e);
        this.reportData = [];
      } finally {
        this.loading = false;
      }
    }
  },

  created: async function () {
    this.profile = JSON.parse(decrypt(sessionStorage.getItem('profile')));
    this.store = JSON.parse(decrypt(sessionStorage.getItem('store')));
    await this.getReport();
  }
}
</script>

<style scoped>
.table th {
  background-color: #f8f9fa;
  font-weight: 600;
}
</style>
